import Vivus from "vivus";
window.Vivus = Vivus;